<div class="carousel-wrapper-parent">
  <div class="bg-img"></div>
  <div class="login-page">
    <div>
      <div class="login-wrapper">
        <div>
          <div class="backBtn">
            <a routerLink="/login">
              <button class="btn-action-icon" title="Back">
                <i id="back"></i>
              </button>
              <img src="/assets/img/3ddv/3ddv_black.png" />
            </a>
          </div>
          <div class="login-wrapper-top">
            <h4 class="mb-3">Reset password</h4>
          </div>
          <div class="login-wrapper-body">
            <div class="mb-2">
              <span class="input-label">Email</span>
            </div>
            <input
              type="email"
              class="email-input"
              name="username"
              id="floatingInput"
              autocomplete="off"
              data-1p-ignore
              [(ngModel)]="email" />
            <div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="showError">Email is not valid</div>
          </div>
          <div class="login-wrapper-bottom">
            <button class="btn-login-main reset-password-btn" type="submit" (click)="sendResetPasswordEmail()">
              Send email
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
